import { PuzzleDifficulty } from '../../shared/analysis/difficulty';
import { formatTimeShort } from '../utils';
import { RULE_NAMES } from '../../shared/analysis/rulemeta';
import { HeaderTag } from './HeaderTag';

/** The difficulty badge on the game page: the band, with the prediction behind a tap. */
export function DifficultyTag({ difficulty }: { difficulty: PuzzleDifficulty }) {
  const secs = Math.round(difficulty.refSolveMs / 1000);
  // Seconds under a minute, m:ss over it — "about 95s" is a number nobody converts in their head.
  const time = secs < 60 ? `${secs}s` : formatTimeShort(difficulty.refSolveMs);
  const needs = difficulty.requiredTechniques.map(r => RULE_NAMES[r]).join(', ');

  return (
    <HeaderTag
      label={difficulty.band}
      tone={`diff-${difficulty.band}`}
      ariaLabel={`Difficulty: ${difficulty.band}. About ${secs} seconds for a typical player. Tap for detail.`}
    >
      <span className="diff-pop-time">~{time}</span>
      <span className="diff-pop-note">
        {/* The honest framing: it is a prediction of the median player's time, not a par
            score, and it is routinely 20-odd percent out on any single puzzle. */}
        typical solve time, predicted from a deduction based solving simulation
      </span>
      {needs && <span className="diff-pop-needs">Needs: {needs}</span>}
    </HeaderTag>
  );
}
